import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Footer as PartnerFooter } from '@pcln/partner-config'
import createMarkup from '../utils/create-markup'

const StyledFooter = styled('div')`
  display: none;

  ${themeGet('mediaQueries.md')} {
    display: block;
  }
`

const Footer = ({ footerHTML, partner }) => {
  const id = partner ? `${partner.plfCode}-global-header` : 'pcln-global-footer'

  if (partner) {
    return (
      <div id="expr-ftr">
        <div className="fixed" id={id} data-testid={id}>
          <PartnerFooter partner={partner} />
        </div>
      </div>
    )
  }

  return footerHTML.length > 0 ? (
    <StyledFooter id="expr-ftr" className="experimental-footer">
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={createMarkup(footerHTML)}
        id={id}
        style={{ visibility: 'hidden' }}
      />
    </StyledFooter>
  ) : null
}

Footer.propTypes = {
  footerHTML: PropTypes.string.isRequired,
  partner: PropTypes.object
}

export default Footer
